import type { BootstrapData } from '../types';
import { profileUrl } from '../profile';

export const seed: BootstrapData = {
  player: {
    id: 'u1',
    name: 'Player One',
    handle: 'playerone',
    profileUrl: profileUrl('playerone'),
    initials: 'P1',
    club: 'Example Golf Club',
    rank: 1,
    elo: 1840,
    handicap: 3.2,
    handicapIndex: 3.2,
    courseHandicap: 4,
    courseHandicapCourse: 'Royal Golf Club',
    courseHandicapTee: 'White',
    matches: 24,
    winRate: 71,
    wins: 17,
    losses: 7,
    draws: 0,
    points: 3200,
    change: 12,
    provisional: false,
  },
  leaderboard: [
    { id: 'u1', name: 'Player One', initials: 'P1', club: 'Example Golf Club', rank: 1, elo: 1840, handicap: 3.2, matches: 24, winRate: 71, points: 1840, change: 12 },
    { id: 'u2', name: 'Player Two', initials: 'P2', club: 'Sample Creek', rank: 2, elo: 1240, handicap: 5.1, matches: 18, winRate: 62, points: 1240, change: 3 },
    { id: 'u3', name: 'Player Three', initials: 'P3', club: 'Demo GC', rank: 3, elo: 1100, handicap: 7.4, matches: 16, winRate: 58, points: 1100, change: -1 },
    { id: 'u4', name: 'Player Four', initials: 'P4', club: 'Practice GC', rank: 4, elo: 980, handicap: 8.0, matches: 12, winRate: 54, points: 980, change: 3 },
    { id: 'u5', name: 'Player Five', initials: 'P5', club: 'Training Club', rank: 5, elo: 870, handicap: 9.6, matches: 10, winRate: 51, points: 870, change: 0 },
  ],
  banners: [
    { id: 'b1', title: 'Victory Cup 2026', subtitle: 'Join the elite tournament. Limited spots remaining.', cta: 'Join now' },
    { id: 'b2', title: 'Royal Academy', subtitle: 'Private lesson slots with PGA coaches.', cta: 'Book lesson' },
  ],
  communities: [
    { id: 'c1', name: 'Russian Golf Community Dubai', members: 148, status: 'approved', logoUrl: null },
    { id: 'c2', name: 'Weekend Match Play Club', members: 64, status: 'not applied', logoUrl: null },
  ],
  tournaments: [
    { id: 't1', title: 'Victory Cup 2026', fieldName: 'Royal Golf Club', forWhom: 'Members and guests', date: 'May 31', time: '07:00', cost: '$120', format: 'Stableford', tees: 'White / Red', status: 'open' },
    { id: 't2', title: 'Community Medal', fieldName: 'Dubai Creek', forWhom: 'Community members', date: 'Jun 12', time: '08:30', cost: '$90', format: 'Stroke play', tees: 'Blue / Red', status: 'pending' },
  ],
  golfClubs: [
    { id: 'g1', name: 'Royal Golf Club', address: 'Dubai Hills', slots: 'Thu 07:20 / 4 slots', imageUrl: null },
    { id: 'g2', name: 'Viya Golf', address: 'Dubai', slots: 'Fri 18:30 / 2 slots', imageUrl: null },
  ],
  coaches: [
    { id: 'a1', name: 'Maria Petrova', specialty: 'Short game and putting', price: '$80 / lesson' },
    { id: 'a2', name: 'James Wilson', specialty: 'Driver and distance', price: '$95 / lesson' },
  ],
  partners: [
    { id: 'p1', name: 'Club Restaurant', category: 'Dine', cashback: '10%' },
    { id: 'p2', name: 'Golf Store Dubai', category: 'Golf', cashback: '7%' },
  ],
  notifications: [{ id: 'n1', title: 'Join request', body: 'A member wants to join your Thursday game.' }],
  activeMatch: null,
  recentMatches: [
    { id: 'm1', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 25, opponentScore: 26, result: 'W' },
    { id: 'm2', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 24, opponentScore: 27, result: 'W' },
    { id: 'm3', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 26, opponentScore: 26, result: 'W' },
    { id: 'm4', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 25, opponentScore: 28, result: 'W' },
    { id: 'm5', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 28, opponentScore: 25, result: 'L' },
    { id: 'm6', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 24, opponentScore: 26, result: 'W' },
    { id: 'm7', courseName: 'Emirates Golf Par 3', opponentName: 'Roman Ludin', opponentInitials: 'RL', myScore: 25, opponentScore: 26, result: 'W' },
  ],
  friends: [
    { id: 'u2', name: 'Player Two', initials: 'P2', city: 'Dubai', homeClub: 'Sample Creek', elo: 1240, handicap: 5.1, matches: 18, winRate: 62 },
  ],
  friendRequests: [],
  appUsers: [
    { id: 'u2', name: 'Player Two', initials: 'P2', city: 'Dubai', homeClub: 'Sample Creek', elo: 1240, handicap: 5.1, matches: 18, winRate: 62 },
  ],
  courses: [
    {
      id: 'course-emirates-par3',
      name: 'Emirates Golf Par 3',
      city: 'Dubai',
      par: 27,
      tees: [{ id: 'tee-emirates-par3-white', name: 'White', color: 'white' }],
      holes: Array.from({ length: 9 }, (_, index) => ({ id: `h${index + 1}`, number: index + 1, par: 3, distance: 100 + index * 5 })),
    },
  ],
  events: [
    {
      id: 'event-par3-community-night',
      title: 'Par 3 Community Night',
      description: 'Friendly evening at Emirates Golf Par 3.',
      date: 'Jun 10',
      location: 'Emirates Golf Club',
      price: '$60',
      status: 'open',
      videoUrl: '/videos/featured-event.webm',
    },
  ],
};
